import { IDENTITY_ENVIRONMENT_TYPE } from "header/environment-selector/ENV_CONSTANTS";

export const resolveGatewayType = (type: string) => {
  return type.toLowerCase() === IDENTITY_ENVIRONMENT_TYPE.PRE_PRODUCTION ? "PRE PROD" : "PROD";
};
